const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcculexLogoJan2021 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b1965b93-17b3-4f6c-b625-d4d74236aab0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.43,34a.51.51,0,0,1-.44-.29L21.1,25.52H10.16L7.28,33.68a.55.55,0,0,1-.44.29H5.62a.23.23,0,0,1-.23-.23.13.13,0,0,1,0-.06L14.4,9a.51.51,0,0,1,.43-.29h1.66a.51.51,0,0,1,.43.29l9,24.69a.22.22,0,0,1-.14.28H24.43Zm-3.9-10L15.65,10.18,10.74,23.93Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,34.42c-6.07,0-9.27-4.35-9.27-11S31,12.4,37.15,12.4c5.08,0,8,2.91,8.49,7.26a.32.32,0,0,1-.27.37H44.16a.44.44,0,0,1-.41-.37A6.2,6.2,0,0,0,37.15,14c-4.92,0-7.22,3.69-7.22,9.43s2.26,9.31,7.14,9.35c3.85,0,6.48-2.25,6.89-6.27a.43.43,0,0,1,.41-.37h1.14a.3.3,0,0,1,.33.28.14.14,0,0,1,0,.09C45.47,31.1,42.48,34.42,37.11,34.42Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,34.42c-6.07,0-9.27-4.35-9.27-11s3.2-11.07,9.31-11.07c5.08,0,8,2.91,8.49,7.26a.32.32,0,0,1-.27.37H64.7a.44.44,0,0,1-.41-.37A6.2,6.2,0,0,0,57.69,14c-4.92,0-7.18,3.69-7.18,9.43s2.26,9.31,7.14,9.35c3.85,0,6.48-2.25,6.89-6.27a.43.43,0,0,1,.41-.37H66.1a.31.31,0,0,1,.33.29s0,.05,0,.08C66,31.1,63,34.42,57.65,34.42Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.93,34a.36.36,0,0,1-.37-.35v0l.12-14.27L90.53,5.64a.36.36,0,0,1,.35-.37h1.4a.37.37,0,0,1,.37.35v0L92.5,19.27l.12,14.35a.36.36,0,0,1-.35.37h0Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,26.51a.33.33,0,0,1,.33.33v0c-.78,4.63-3.61,7.54-8.65,7.54-6.27,0-9.56-4.47-9.56-11s3.61-11.07,9.27-11.07,8.94,3.9,9.06,10.58a.36.36,0,0,1-.35.37H98.61c0,5.95,2.5,9.43,7.46,9.43,3.85,0,6-2.21,6.68-5.94a.41.41,0,0,1,.41-.37ZM105.78,14c-4.14,0-6.6,3-7.09,7.71h14C112.63,17.45,110.29,14,105.78,14Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,34a.76.76,0,0,1-.58-.29l-6.27-9.47-6.31,9.47a.76.76,0,0,1-.58.29h-1.47a.2.2,0,0,1-.2-.18.2.2,0,0,1,0-.11l7.31-10.86-6.52-9.68a.18.18,0,0,1,.06-.26.19.19,0,0,1,.1,0h1.64a.8.8,0,0,1,.58.29l5.53,8.28,5.41-8.24a.72.72,0,0,1,.58-.33h1.43a.21.21,0,0,1,.21.21.25.25,0,0,1,0,.12l-6.32,9.64,7.26,10.86a.18.18,0,0,1-.06.26.19.19,0,0,1-.1,0Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.31,25.27,154,26.76a.42.42,0,0,1,.11.58.57.57,0,0,1-.11.11l-9.79,6.43a.3.3,0,0,1-.34,0l-9.94-6.39a.44.44,0,0,1-.1-.6l.1-.1,2.74-1.52",
    style: {
      fill: "none",
      stroke: "#5079e3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,21.42,154,22.9a.42.42,0,0,1,.11.58.57.57,0,0,1-.11.11L144.21,30a.3.3,0,0,1-.34,0l-9.94-6.43a.44.44,0,0,1-.1-.6.47.47,0,0,1,.1-.1l2.63-1.46",
    style: {
      fill: "none",
      stroke: "#5079e3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,19.69l-9.79,6.39a.3.3,0,0,1-.34,0l-10-6.43a.44.44,0,0,1-.1-.6.47.47,0,0,1,.1-.1l9.82-5.46a.32.32,0,0,1,.3,0L154,19a.42.42,0,0,1,.11.58l-.11.11",
    style: {
      fill: "none",
      stroke: "#5079e3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,32.74c3.2,0,5.33-1.93,5.33-7V13.22a.38.38,0,0,1,.37-.37h1.35a.38.38,0,0,1,.37.37h0l-.08,8.7v4c0,5.79-2.62,8.53-6.89,8.53H76.59c-4.26,0-6.89-2.74-6.89-8.53v-4l-.08-8.65A.38.38,0,0,1,70,12.9h1.35a.38.38,0,0,1,.37.37h0V25.78c0,5.08,2.13,7,5.33,7h1Z",
    style: {
      fill: "#232425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.38,26.08V13.5a.37.37,0,0,0-.37-.36H83.68a.37.37,0,0,0-.37.35V25.86c0,5.63-2.73,6.9-5.81,6.88s-5.83-1.47-5.83-7.1V13.27c0-.2-.86-.12-1-.12h-.62a.37.37,0,0,0-.37.36V26.08c0,5.92,3.39,8.67,7.82,8.65S85.38,32,85.38,26.08Z",
    style: {
      fill: "#232425"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcculexLogoJan2021);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/acculex-logo-Jan2021.88990ca3e87230ced64d896ca76c7253.svg";